import { Plan, PlanDefinition } from "./types";
import {
    MONTHLY_PRICE_PER_CREDIT,
    ANNUAL_PRICE_PER_CREDIT,
    STANDARD_PRICE_PER_CREDIT_USD
} from "./info/ubp";
import { LIMITS_CONFIG } from "./info/limits";
import { FEATURES_CONFIG } from "./info/featureFlags";
import { PLAN_PRICING } from "./info/pricing";
import { PLAN_META } from "./info/meta";
import { PLAN_UBP } from "./info/ubp";
import {
    TRAIN_CONFIG,
    INFERENCE_CONFIG,
    AUTO_LABEL_CONFIG,
    VIDEO_INFERENCE_CONFIG,
    TFJS_CONFIG,
    OAK_CONFIG,
    TENSORRT_CONFIG,
    COREML_CONFIG
} from "./info/legacyLimits";
import {
    CANCELLATION_OFFERS,
    getEligibleCancellationOffer,
    getCancellationOfferById
} from "./info/cancellationOffers";

export { MONTHLY_PRICE_PER_CREDIT, ANNUAL_PRICE_PER_CREDIT, STANDARD_PRICE_PER_CREDIT_USD };
export { CANCELLATION_OFFERS, getEligibleCancellationOffer, getCancellationOfferById };
export type {
    CancellationOfferContext,
    CancellationOfferDefinition,
    CancellationOfferVariant
} from "./info/cancellationOffers";

const createPlanDefinition = (plan: Plan): PlanDefinition => {
    const workspacePlan =
        plan === Plan.UninitalizedWorkspace || plan === (null as unknown as Plan)
            ? null
            : (plan as unknown as string);

    return {
        plan,
        pro: [
            Plan.UbpBasic,
            Plan.UbpCore,
            Plan.UbpGrowth,
            Plan.UbpPremiumTrial,
            Plan.EnterpriseGrowth,
            Plan.Enterprise,
            Plan.LegacyStarter
        ].includes(plan),
        restricted: false,
        meta: PLAN_META[plan],
        price: PLAN_PRICING[plan],
        ubp: PLAN_UBP[plan],
        limit: LIMITS_CONFIG[plan],
        train: TRAIN_CONFIG[plan] as any,
        soft: false,
        inference: INFERENCE_CONFIG[plan],
        video_inference: VIDEO_INFERENCE_CONFIG[plan],
        auto_label: AUTO_LABEL_CONFIG[plan],
        tfjs: TFJS_CONFIG[plan],
        oak: OAK_CONFIG[plan],
        tensorrt: TENSORRT_CONFIG[plan],
        coreml: COREML_CONFIG[plan],
        features: FEATURES_CONFIG[plan],
        workspace: { isSetup: true, team: true, plan: workspacePlan }
    };
};

export const PLANS: Record<Plan, PlanDefinition> = (
    Object.values(Plan) as Array<Plan | null>
).reduce(
    (acc, planValue) => {
        if (planValue && planValue !== ("null" as any) && planValue !== Plan.Legacy) {
            const typedPlan = planValue as Plan;
            acc[typedPlan] = createPlanDefinition(typedPlan);
        }
        return acc;
    },
    {} as Record<Plan, PlanDefinition>
);

PLANS[Plan.UninitalizedWorkspace] = createPlanDefinition(Plan.UninitalizedWorkspace);
PLANS[Plan.UninitalizedWorkspace].plan = null;
PLANS[Plan.UninitalizedWorkspace].workspace.plan = null;
PLANS[Plan.UninitalizedWorkspace].workspace.isSetup = false;
PLANS[Plan.UninitalizedWorkspace].threshold = 100;
PLANS[Plan.UninitalizedWorkspace].rates = { sources: 1000, transforms: 200 };
PLANS[Plan.UninitalizedWorkspace].total = 0;
PLANS[Plan.UninitalizedWorkspace].images = { sources: 0, transforms: 0 };

// Fallback for legacy plan not in enum
PLANS[Plan.Legacy] = {
    ...PLANS[Plan.Public],
    plan: Plan.Legacy,
    workspace: { ...PLANS[Plan.Public].workspace, plan: Plan.Legacy },
    meta: {
        title: "Legacy Plan",
        description: "",
        tagline: "",
        icon: "far fa-scroll-old",
        support: "Priority Support"
    }
};
